import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true, layout: 'blank' },
  },
  {
    path: '/library',
    name: 'library',
    component: () => import('@/views/PhotoLibraryView.vue'),
  },
  {
    path: '/upload',
    name: 'upload',
    component: () => import('@/views/PhotoUploadView.vue'),
  },
  {
    path: '/datasets',
    name: 'datasets',
    component: () => import('@/views/DatasetListView.vue'),
  },
  {
    path: '/datasets/:id',
    name: 'dataset-detail',
    component: () => import('@/views/DatasetDetailView.vue'),
  },
  {
    path: '/datasets/:id/versions/new',
    name: 'dataset-version-create',
    component: () => import('@/views/DatasetVersionCreateView.vue'),
  },
  {
    path: '/datasets/:id/versions/:version',
    name: 'dataset-version-detail',
    component: () => import('@/views/DatasetVersionDetailView.vue'),
  },
  {
    path: '/leaderboard',
    name: 'leaderboard',
    component: () => import('@/views/LeaderboardView.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminView.vue'),
    meta: { requiresSuperadmin: true },
  },
  {
    path: '/trash',
    name: 'trash',
    component: () => import('@/views/TrashView.vue'),
    meta: { requiresManage: true },
  },
  { path: '/', redirect: { name: 'library' } },
  { path: '/:pathMatch(.*)*', redirect: { name: 'library' } },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (to.meta.public) {
    return true
  }
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (auth.isAuthenticated && !auth.user) {
    // Page reload: token in storage but no user yet. Hydrate.
    try {
      await auth.fetchMe()
    } catch {
      auth.logout()
      return { name: 'login' }
    }
  }
  // superadmin-only routes (e.g. 帳號管理). Backend enforces too; this just hides
  // the page from non-superadmins.
  if (to.meta.requiresSuperadmin && !auth.isSuperadmin) {
    return { name: 'library' }
  }
  if (to.meta.requiresManage && !auth.isManager) {
    return { name: 'library' }
  }
  return true
})
